import React from "react";
import "../LegalWarningModal.css";

function LegalWarningModal({ show, onClose }) {
  if (!show) return null;

  return (
    <div className="legal-modal-overlay">
      <div className="legal-modal">
        <h2>Unauthorized Capture Detected</h2>

        <p>
          Screenshots, screen recording, copying, or redistribution of this
          content is strictly prohibited.
        </p>

        <p>
          This activity has been logged.
        </p>

        <p className="legal-warning">
          Continued violations may result in account termination and legal
          action under U.S. copyright law.
        </p>

        <button onClick={onClose}>I Understand</button>
      </div>
    </div>
  );
}

export default LegalWarningModal;
